"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var setup = {
  description: 'Create a custom policy to protect your API and meet your specific business needs.',
  hidden: true,
  flows: [{
    fields: [{
      name: 'binary',
      label: 'Binary file',
      inputType: 'file',
      classifier: 'binary',
      extensions: ['.jar', '.wasm'],
      required: true
    }, {
      name: 'metadata',
      label: 'Metadata file',
      inputType: 'file',
      classifier: 'metadata',
      extensions: ['.yaml'],
      required: true
    }]
  }]
};
var _default = exports.default = setup;
//# sourceMappingURL=form.js.map